import { createAction, createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterUsersProps, ReduxUsersSearchState, UsersGridParams } from "../types";
import { ReduxSliceState } from "../../../shared/types";
import { withPayloadType } from "../../../shared/utils";
import { UserItem } from "../../../api/types";
import { ReduxRootState } from "../../../shared/redux/store";

const initialState: ReduxUsersSearchState = {
    state: 'BUSY',
    users: [],
    usersGridParams: {
        sortCol: 'email',
        sortDir: 'desc',
        search: undefined,
        active: true,
        limit: 500,
        previousPage: undefined,
        nextPage: undefined,
    },
};

export const loadUsers = createAction('users/loadUsers');
export const filterUsers = createAction('users/search/filter', withPayloadType<FilterUsersProps>());

const usersSearchSlice = createSlice({
    name: 'users/search',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setUsers: (state, action: PayloadAction<UserItem[]>) => {
            state.users = [...action.payload];
        },
        updateGridParams: (state, action: PayloadAction<Partial<UsersGridParams>>) => {
            state.usersGridParams = {
                ...state.usersGridParams,
                ...action.payload,
            };
        },
    }
});

export default usersSearchSlice;

const selectSelf = (state: ReduxRootState) => state.usersSearch;
export const selectUsersSearchState = createSelector(selectSelf, self => self.state);
export const selectUsersSearchIsBusy = createSelector(selectUsersSearchState, state => state === 'BUSY');
export const selectUsersSearchUsers = createSelector(selectSelf, self => self.users);
export const selectUsersSearchGridParams = createSelector(selectSelf, self => self.usersGridParams);
export const selectUsersSearchGridParamsSearch = createSelector(selectUsersSearchGridParams, params => params.search);
export const selectUsersSearchGridParamsActive = createSelector(selectUsersSearchGridParams, params => params.active);